import EmberFlatpickr from 'ember-flatpickr/components/ember-flatpickr';
import type { ComponentLike } from '@glint/template';
import type { BaseOptions as FlatpickrOptions } from 'flatpickr/dist/types/options';

/**
 * Typed re-export of EmberFlatpickr.
 *
 * ember-flatpickr@9 declares every flatpickr option as a REQUIRED component arg,
 * but they are all optional at runtime (only `@date` + `@onChange` are typically
 * passed). Re-typing the args as `Partial<…>` lets call sites use `<Flatpickr>`
 * without a per-invocation `{{! @glint-expect-error }}`. This is the exact same
 * component at runtime — purely a type relaxation.
 */
const Flatpickr = EmberFlatpickr as unknown as ComponentLike<{
  Element: HTMLInputElement;
  Args: Partial<
    FlatpickrOptions & {
      date: FlatpickrOptions['defaultDate'];
      disabled: boolean;
    }
  >;
  Blocks: { default: [] };
}>;

export default Flatpickr;
